"use client";
import React from "react";

function PopularGuide() {
  const services = [
    {
      title: "Regulatory Compliance",
      desc: "We assist businesses in understanding and adhering to industry-specific regulations, ensuring that operations align with legal requirements.."
    },
    {
      title: "Corporate Governance",
      desc: "Strengthen your corporate structure with our expertise in establishing and maintaining effective governance practices.."
    },
    {
      title: "Employment Law",
      desc: "Navigate the complexities of employment regulations, from drafting policies to handling disputes, with our comprehensive employment law compliance services.."
    },
    {
      title: "ITR E-Verification",
      desc: "To electronically verify your Income Tax Return (ITR) for the Financial Year 2023-24, you can use various methods approved by the Income Tax Department of India."
    }
  ];

  return (
    <section className="popular-guide">
      <div className="container">

        {/* HEADING */}
        <div className="mb-4">
          <h2 className="main-heading">
            Our Legal Compliance Services
          </h2>
        </div>

        <div className="row align-items-center">

          {/* LEFT */}
          <div className="col-lg-5 mb-4 left-content">
            <p>
              Our legal compliance services offer comprehensive solutions to ensure that businesses operate in accordance with applicable laws and regulations. We specialize in guiding organizations through the complex landscape of legal requirements, helping them navigate diverse areas such as labor laws, environmental regulations, data protection, and corporate governance.
            </p>
            <p>
              Our legal compliance services offer comprehensive solutions to ensure that businesses operate in accordance with applicable laws and regulations. We specialize in guiding organizations through the complex landscape of legal requirements, helping them navigate diverse areas such as labor laws, environmental regulations, data protection, and corporate governance.
            </p>
            <p>
              From drafting policies and procedures to conducting compliance audits, our services are designed to enhance transparency, mitigate legal risks, and foster a culture of lawful operations within the business environment. By engaging our legal compliance services, businesses can fortify their legal standing, demonstrate ethical governance, and ensure sustained success in today's regulatory landscape.
            </p>
          </div>

          {/* RIGHT */}
          <div className="col-lg-7">
            <div className="row g-4">
              {services.map((item, index) => (
                <div className="col-md-6" key={index}>
                  <div className="service-card">
                    <div className="card-inner">
                      <h5>{item.title}</h5>
                      <p>{item.desc}</p>
                      <span className="hover-line"></span>
                    </div>
                  </div>
                </div>
              ))}

            </div>
          </div>

        </div>
      </div>

      <style jsx>{`

        .popular-guide {
          padding: 80px 0;
          background: linear-gradient(135deg, #eef5ff, #ffffff);
        }

        /* Heading */
        .main-heading {
          font-size: 34px;
          font-weight: 800;
          color: #115886;
          position: relative;
        }

        .main-heading::after {
          content: "";
          width: 60px;
          height: 4px;
          
          display: block;
          margin-top: 10px;
          border-radius: 2px;
        }

        /* Left Content */
        .left-content p {
          color: #6b7280;
          line-height: 1.8;
          margin-bottom: 15px;
        }

        /* Cards */
        .service-card {
          padding: 2px;
          border-radius: 18px;
          background: linear-gradient(135deg, #105784, #06b6d4);
          transition: 0.4s;
        }

        .card-inner {
          background: rgba(255,255,255,0.9);
          backdrop-filter: blur(10px);
          border-radius: 16px;
          padding: 25px;
          height: 100%;
          position: relative;
          overflow: hidden;
          transition: 0.3s;
        }

        .card-inner h5 {
          font-weight: 700;
          color: #105784;
          margin-bottom: 10px;
        }

        .card-inner p {
          color: #6b7280;
          font-size: 14px;
        }

        /* Hover Effects */
        .service-card:hover {
          transform: translateY(-10px) scale(1.02);
          box-shadow: 0 20px 40px rgba(0,0,0,0.1);
        }

        .hover-line {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 0%;
          height: 3px;
          background: #105784;
          transition: 0.3s;
        }

        .service-card:hover .hover-line {
          width: 100%;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .main-heading {
            font-size: 26px;
          }
        }

      `}</style>
    </section>
  );
}

export default PopularGuide;